export const getCourseTitle = (
  course: {
    publicTitle?: string;
    privateTitle?: string;
  } = {}
) => course?.publicTitle ?? course?.privateTitle;
